import { useDispatch } from 'react-redux';
import { applyMiddleware, combineReducers, createStore as createReduxStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension/logOnlyInProduction';
import { combineEpics, createEpicMiddleware } from 'redux-observable';
import { modalReducer } from '../../src/components/webApp/auth/authRedux/authReducer';
import {
  confirmPasswordEpic,
  forgotPasswordEpic,
  signInEpic,
  signOutEpic,
  signUpConfirmCodeEpic,
  signUpEpic,
} from '../components/webApp/auth/authRedux/epic';

const rootReducer = combineReducers({
  modal: modalReducer,
});

const rootEpic = combineEpics(
  signUpEpic,
  signInEpic,
  forgotPasswordEpic,
  signUpConfirmCodeEpic,
  confirmPasswordEpic,
  signOutEpic,
);

const LOCAL_STORAGE_KEY = 'appState';

function loadState() {
  if (typeof window === 'undefined') {
    return undefined;
  }

  try {
    const data = localStorage.getItem(LOCAL_STORAGE_KEY);

    return data ? JSON.parse(data) : undefined;
  } catch {
    return undefined;
  }
}

function saveState(state) {
  if (typeof window === 'undefined') {
    return;
  }

  localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify({ modal: state.modal }));
}

export function createStore() {
  const epicMiddleware = createEpicMiddleware();

  const store = createReduxStore(rootReducer, loadState(), composeWithDevTools(applyMiddleware(epicMiddleware)));

  epicMiddleware.run(rootEpic);

  store.subscribe(() => {
    saveState(store.getState());
  });

  return store;
}

export const store = createStore();
export type RootState = ReturnType<typeof rootReducer>;
export type AppDispatch = typeof store.dispatch;
